import { useEffect, useState } from 'react';

import type { ISource } from '../models';

import { findBackgroundByMedia } from './find-background-by-media';

export const useBackgroundByMedia = (
    sources: ISource[],
    onChange: ({ source }: { source?: ISource }) => void
) => {
    const [background, setBackground] = useState<ISource>();

    useEffect(() => {
        const onWindowResize = () => {
            setBackground(findBackgroundByMedia(sources));
        };

        onWindowResize();
        window?.addEventListener('resize', onWindowResize);

        return () => {
            window?.removeEventListener('resize', onWindowResize);
        };
    }, [sources]);

    useEffect(() => {
        onChange({ source: background });
    }, [background, onChange]);

    return { background, setBackground };
};
